// extracted by mini-css-extract-plugin
module.exports = {"textarea":"TextArea_textarea__aLpy0","default":"TextArea_default__boQP0","big":"TextArea_big__AZBvU","small":"TextArea_small__GiRB_","full":"TextArea_full__3oJRe"};